import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetActivitySchema, GetSupportActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetSupportActivityResponseDataSchema>>

type Query = z.input<typeof GetActivitySchema>

type Props = {
  enabled?: boolean
  query?: Query
}

export function getSupportActivityQueryKey() {
  return ["supportActivity"]
}

export const supportActivityQuery = ({ enabled = false, query }: Props = {}) => {
  return queryOptions({
    queryKey: [...getSupportActivityQueryKey(), JSON.stringify(query)],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/activity/support`, { params: query })
      return response.data.data
    },
    enabled,
  })
}
